import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from '../ViewCatalogProductsContext';

const PriceCell = (props: GridCellProps) => {
  const intl = useInternationalization();
  const { value } = useGridCellDisplayValue(props);
  const isLb = useMemo(
    () => String(props.dataItem?.uom).toLowerCase() === 'lb',
    [props.dataItem?.uom]
  );
  const formattedPrice = intl.format(isLb ? '{0:c3}' : '{0:c2}', Number(value));
  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );
  const isExternalSupplier = !!(selectedCatalog && selectedCatalog?.catalogType === 2);
  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={isExternalSupplier ? false : true}
      className="!p-0"
      title={formattedPrice}
    >
      {formattedPrice}
    </GridCellBase>
  );
};

export default PriceCell;
